import React, { useEffect, useState } from "react";

import axios from "../../axios-instance.js";

import "./OpenSell.sass";
import { getCurrentLanguageTexts } from "../../constants/seasonPassPersonalInfoLangs.js";
import CheckBox from "../../components/UI/Checkbox/CheckBox.js";
import { entreeTicketToSeatsIointerface, getSeatSideLabel, hasSeatTicket, isNoSeatTicket, isSeatsIoNoSeatTicket, isSeatsIoTicket } from "../../helpers/ticketHelper.ts";
import closeIcon from "../../images/ic_x_2.svg";

const renderSeatsIoTicket = (
  {
    currency,
    category: { label },
    labels: { section, parent, own },
    pricing,
    allowBuyNfc = false,
    isNfcChecked = false,
    handleNfcChange = null,
  },
  i,
  removeTicket,
) => {
  const [area, side] = !!section ? section.split("-") : ['', ''];
  const price = pricing.price || null;

  return (
    <div key={i} className="partizan-open-selling__selected-tickets-item">

      <div className="partizan-open-selling__selected-tickets-item-labels">

        <span className="partizan-open-selling__text-normal partizan-open-selling__selected-tickets-seat">
          {label} {area}, Row {parent} Seat {own} {() => side ? side : ''}
        </span>

        <span className="partizan-open-selling__text-bold price">
          {price} {currency}
        </span>

        <img
          src={closeIcon}
          className="partizan-open-selling__selected-tickets-close"
          alt="close"
          onClick={removeTicket}
        />

      </div>

      {allowBuyNfc &&
        <CheckBox
          name="buyNfcCard"
          id={`buy-nfc-card_${i}`}
          checked={isNfcChecked}
          onChange={(v) => {
            handleNfcChange(!isNfcChecked, `${section}-${parent}-${own}`)
          }}>
          Add NFC
        </CheckBox>}
    </div>
  );
};

const renderSeatsIoNoSeatTicket = (
  {
    currency,
    category: { label },
    labels: { own },
    numSelected,
    pricing,
  },
  i,
  removeTicket,
) => {
  const price = pricing.price || null;

  return (
    <div key={i} className="partizan-open-selling__selected-tickets-item">

      <div className="partizan-open-selling__selected-tickets-item-labels">

        <span className="partizan-open-selling__text-normal partizan-open-selling__selected-tickets-seat">
          {label}
        </span>

        <span className="partizan-open-selling__text-bold price">
          {price * numSelected} {currency}
        </span>

        <img
          src={closeIcon}
          className="partizan-open-selling__selected-tickets-close"
          alt="close"
          onClick={removeTicket}
        />

      </div>
    </div>
  );
};

const renderTicketWithSeats = ({ name, price, currency, count, couponData, area, side, row, seat }, i
) => {

  return (
    <div key={i} className="partizan-open-selling__selected-tickets-item">

      <div className="partizan-open-selling__selected-tickets-item-labels">

        <span className="partizan-open-selling__text-normal">
          {name}, {area} {getSeatSideLabel(side)}, Row {row} Seat {seat}
        </span>

        <span className="partizan-open-selling__text-bold price">
          {price} {currency}
        </span>

      </div>

    </div>
  );
};

const renderTicket = ({ name, price, currency, count, couponData, ticketTemplateId, ...keys }, i, isOfferPage, removeTicket) => {

  let fixedDiscount = 0;
  if (couponData) {
    if (!couponData.ticketTypeIds || couponData.ticketTypeIds.length === 0) {
      fixedDiscount = couponData.fixedDiscount;
    }
    else if (couponData.ticketTypeIds && couponData.ticketTypeIds.filter((v) => (v === ticketTemplateId)).length > 0 && couponData.ticketTypeIds.filter((v) => (v === ticketTemplateId)).length <= count) {
      fixedDiscount = couponData.fixedDiscount;
    }
  }

  return (
    <div key={i} className="partizan-open-selling__selected-tickets-item">
      <div className="partizan-open-selling__selected-tickets-item-labels">
        <span className="partizan-open-selling__text-normal partizan-open-selling__selected-tickets-seat">{name}</span>
        <span className="partizan-open-selling__text-bold price">
          {(price * count
            - (couponData ? (price * (count > 2 ? 2 : count) * couponData.discount) / 100 : 0)
            - fixedDiscount
          ).toFixed(2)}{" "}
          {currency}
        </span>

        {!isOfferPage && !keys.masterTicket && (
          <img
            src={closeIcon}
            className="partizan-open-selling__selected-tickets-close"
            alt="close"
            onClick={removeTicket}
          />
        )}
      </div>
    </div>
  )
}

export const SelectedTickets = ({
  tickets = [],
  setCouponHandler,
  coupon,
  currency,
  total,
  totalFee,
  hasSeats,
  mixedTickets,
  event,
  ticketAdd,
  ticketRemove,
  allowEnterCouponCode = true,
  autoHeight = false,
  pointsForDiscount = 0,
  allowManualDiscount = false,
  manualDiscount = 0,
  setManualDiscount = () => null,
  popupMode = false,
  theme = null,
  isTermsChecked,
  handleChangeCheckbox,
  showTermsAndConditionsModal,
  isTermsCheckbox = true,
  isOfferPage = false,
  onObjectDeselected,
  isMapLoading = false
}) => {
  const txt = getCurrentLanguageTexts();

  const [couponCode, setCouponCode] = useState(coupon ? coupon.barcode : "");
  const [couponData, setCouponData] = useState(coupon);
  const [focusedElement, setFocusedElement] = useState(null);

  useEffect(() => {
    setCouponData(coupon);
    setCouponCode(coupon ? coupon.barcode : "");
  }, [coupon]);


  const eventid = event ? event.eventId : 0;
  const isSeasonEvent = eventid == process.env.REACT_APP_NEW_SEASON_EVENT_ID;
  const nfcTicketTemplate = isSeasonEvent
    ? event.ticketTemplates.find(t => t.ticketTemplateId == process.env.REACT_APP_NEW_SEASON_NFC_CARD_TICKET_TEMPLATE_ID)
    : null;

  const handleCouponChanges = async (e) => {
    // e.preventDefault();
    // debounce(setSearch(e.target.value.toUpperCase()), 500)// debounce 500 milliseconds
    // console.log(couponCode);
    // console.log(event);

    const code = e.target.value.toLowerCase();

    setCouponCode(code);

    try {
      var response = await axios.get(
        "/Transaction/couponDetails?couponCode=" +
        code +
        "&eventId=" +
        event.eventId,
        {}
      );

      if (response.data && response.data.isSuccess) {
        setCouponData(response.data.result);
        setCouponHandler(response.data.result);
      }
    } catch (ex) {
      console.log(ex);
    }
  };

  if (hasSeats && isMapLoading) {
    return null
  }

  if (!tickets.length) {
    return (
      <div className="partizan-open-selling__empty-tickets">
        <img src="/images/img-empty-events.svg" alt="Select Ticket" />
        <p>
          {hasSeats
            ? txt.sellPageTxt["Select a ticket on the map"]
            : txt.sellPageTxt["Add a ticket from the list"]}
        </p>
      </div>
    );
  }

  const hasSeat = (ticket) => {
    return isSeatsIoTicket(ticket);
  }

  const renderTickets = () => {
    return tickets.map((ticket, i) => {
      const removeTicket = () => {
        onObjectDeselected(ticket);
      };

      if (hasSeat(ticket)) {
        return renderSeatsIoTicket({
          ...ticket,
          currency,
          allowBuyNfc: isSeasonEvent,
          isNfcChecked: ticket.isNfcChecked,
          handleNfcChange: (v, label) => {
            ticket.isNfcChecked = v;

            if (v) {
              ticket.nfc = entreeTicketToSeatsIointerface({}, nfcTicketTemplate);

              ticket.nfc.name = ticket.nfc.name + ` ${ticket.id}`;

              ticket.nfc.masterTicket = ticket;
              ticket.nfc.id = Math.random();

              if (ticketAdd) ticketAdd(ticket.nfc);
            }
            else if (ticket.nfc && ticketRemove) {
              ticketRemove(ticket.nfc);
            }
          }
        }, i, removeTicket)
      } else if (isSeatsIoNoSeatTicket(ticket)) {
        return renderSeatsIoNoSeatTicket({
          ...ticket,
          currency,
          allowBuyNfc: false,
        }, i, removeTicket)
      } else {
        if (hasSeatTicket(ticket)) {
          return renderTicketWithSeats({ ...ticket, currency: currency }, i)
        } else {
          return renderTicket({
            ...ticket,
            currency,
            couponData
          }, i, isOfferPage, removeTicket)
        }
      }
    })

    /* return ticketFromMap.map((ticket, i) =>
      renderSeatsIoTicket({
        ...ticket,
        currency,
        allowBuyNfc: isSeasonEvent,
        isNfcChecked: ticket.isNfcChecked,
        handleNfcChange: (v, label) => {
          ticket.isNfcChecked = v;

          if (v) {
            ticket.nfc = entreeTicketToSeatsIointerface({}, nfcTicketTemplate);

            ticket.nfc.name = ticket.nfc.name + ` ${ticket.id}`;

            ticket.nfc.masterTicket = ticket;
            ticket.nfc.id = Math.random();

            if (ticketAdd) ticketAdd(ticket.nfc);
          }
          else if (ticket.nfc && ticketRemove) {
            ticketRemove(ticket.nfc);
          }
        }
      }, i)
    ).concat(ticketNoSeats.map((ticket, i) =>
      hasSeatTicket(ticket)
        ? renderTicketWithSeats({ ...ticket, currency: currency }, i)
        : renderTicket({
          ...ticket,
          currency,
          couponData
        }, i + ticketFromMap.length)
    )); */
  };

  const totalTickets = () => {

    const total = tickets.reduce((a,t) => {
      return a + t.count
      || t.numSelected
      || 1;
    }, 0);

    console.log(total);

    return total;

    // const ticketFromMap = tickets.filter(t => hasSeat(t));
    // const ticketFromMapNoSeat = tickets.filter(t => isSeatsIoNoSeatTicket(t));
    // const ticketNoSeats = tickets.filter(t => isNoSeatTicket(t));
    
    // const noSeatsTotal = ticketNoSeats.reduce((acc, t) => acc + t.count, 0)
    // + ticketFromMapNoSeat.reduce((acc, t) => acc + t.numSelected, 0);
    
    // return noSeatsTotal + ticketFromMap.length;
  };

  const handleMouseEnter = (e) => {
    if (theme && focusedElement !== e.target.name) {
      e.target.style.borderColor = theme.primarySemiLightColor;
    }
  };
  const handleMouseLeave = (e) => {
    if (theme && focusedElement !== e.target.name) {
      e.target.style.borderColor = '#f1f1f1';
    }
  };
  const handleFocusElement = (e) => {
    if (theme) {
      e.target.style.borderColor = theme.primaryColor;
      setFocusedElement(e.target.name);
    }
  }
  const handleBlureElement = (e) => {
    if (theme) {
      e.target.style.borderColor = '#f1f1f1';
    }
    setFocusedElement(null);
  };

  const toggleCheckbox = () => {
    handleChangeCheckbox("termsAndConditionsChecked");
  }

  return (
    <>
      <div style={{ height: autoHeight ? 'auto' : '' }} className="partizan-open-selling__selected-tickets">
        <h4 className="partizan-open-selling__text-bold">{txt.SelectTicketTxt['tickets']} x {totalTickets()}</h4>
        {renderTickets()}
      </div>

      <div className="partizan-open-selling__total">
        {totalFee !== 0 && (
          <div>
            <span className="partizan-open-selling__text-bold-large">
              {txt.SelectTicketTxt['bookingFee']}:
            </span>
            <span className="partizan-open-selling__text-bold-large">
              {totalFee.toFixed(2)} {currency}
            </span>
          </div>
        )}

        {/* {feeRate > 0 && (
          <div>
            <span className="partizan-open-selling__text-bold-large">
              {txt.SelectTicketTxt['bookingFee']}:
            </span>
            <span className="partizan-open-selling__text-bold-large">
              {Math.round((feeRate * 10000)) / 100}%
            </span>
          </div>
        )} */}

        {pointsForDiscount
          ? <div>
            <span className="partizan-open-selling__text-bold-large">{txt.SelectTicketTxt['usedPoints']}:</span>
            <span className="partizan-open-selling__text-bold-large">
              -{pointsForDiscount} {currency}
            </span>
          </div>
          : ''
        }

        <div>
          <span className="partizan-open-selling__text-bold-large">{txt.SelectTicketTxt['total']}:</span>
          <span className="partizan-open-selling__text-bold-large">
            {total} {currency}
          </span>
        </div>
        <div className="partizan-open-selling__vat">{txt.SelectTicketTxt['includedVAT']}</div>
      </div>
      {allowEnterCouponCode && (
        <div className="partizan-open-selling__input_block">
          <label>{txt.sellPageTxt["Coupon code"]}</label>
          <input
            className="seasonpass__field-input"
            placeholder={txt.sellPageTxt["Enter coupon code"]}
            name="couponCode"
            onChange={(e) => handleCouponChanges(e)}
            onMouseEnter={handleMouseEnter}
            onFocus={handleFocusElement}
            onMouseLeave={handleMouseLeave}
            onBlur={handleBlureElement}
            type="text"
            value={couponCode}
            disabled={couponData}
          />
        </div>
      )}

      {allowManualDiscount && (
        <div className="partizan-open-selling__input_block">
          <label>Manual discount</label>
          <input
            className="seasonpass__field-input"
            placeholder="Enter fixed discount"
            name="manualDiscount"
            onChange={(e) => setManualDiscount(e.target.value)}
            onMouseEnter={handleMouseEnter}
            onFocus={handleFocusElement}
            onMouseLeave={handleMouseLeave}
            onBlur={handleBlureElement}
            type="number"
            value={manualDiscount ? Number(manualDiscount).toString() : ''}
          />
        </div>
      )}

      {isTermsCheckbox && (
        <CheckBox
          checked={isTermsChecked}
          id="terms-and-conditions-checkbox"
          name="terms-and-conditions-checkbox"
        // onChange={() => toggleCheckbox()}
        // onClick={() => toggleCheckbox()}
        >
          <span
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '120px',
              height: '30px',
              zIndex: "20"
            }}
            onClick={() => toggleCheckbox()}
          ></span>
          <span
            className="partizan-open-selling__text-medium-small"

          >
            {txt.sellPageTxt["I agree with"]}
            <span
              className="partizan-open-selling__terms-of-service-text"
              onClick={showTermsAndConditionsModal}
              style={{
                color: theme ? theme.secondaryColor : '',
              }}
            >
              {txt.sellPageTxt["Terms of Service"]}
            </span>
          </span>
        </CheckBox>
      )}
    </>
  );
};
